import React from "react";
import LockGameButton from "../Buttons/LockGameButton";
import LeaveButton from "../Buttons/LeaveButton";
import GameOverButton from "../Buttons/GameOverButton";
import RemovePlayerButton from "../Buttons/RemovePlayerButton";
import SitOutButton from "../Buttons/SitoutButton";
import InviteButton from "../Buttons/InviteButton";
import TakePictureButton from "../Buttons/TakePictureButton";
import ToggleCameraButton from "../Buttons/ToggleCameraButton";
import { useSelector } from "react-redux";
import StartVideo from "../Buttons/StartVideoButton";
import { selectIsSessionActive } from "../../slice/gameStateSlice";

const GameControlPanel = ({ isMeetingJoined }) => {
  const gameState = useSelector((state) => state.gameState);
  const user = useSelector((state) => state.auth.user);
  const isSessionActive = useSelector(selectIsSessionActive);

  const isHost = user?.Id === gameState.GameCreatorId;

  // DC-MULTITAB: If session is inactive (another tab took over), show lockout message
  if (!isSessionActive) {
    return (
      <div className="dc-session-inactive">
        <p>This tab is no longer active for this game.</p>
        <p>Your session has moved to another tab or window.</p>
      </div>
    );
  }

  return (
    <>
      <div className="row">
        <div className="col-12 col-sm-10">
          {/* Host-only admin controls (DC-FE-SWAMP-UX-TRIAGE-001) */}
          {isHost && (
            <div className="d-inline-block border rounded bg-light p-2 me-3 mb-2">
              <GameOverButton />
              <RemovePlayerButton />
              <LockGameButton />
              <InviteButton />
            </div>
          )}
          {/* Common controls for all players */}
          <LeaveButton />
          <SitOutButton />
          {gameState.VideoChatAllowed && <StartVideo />}
        </div>
        <div className="col-12 col-sm-2 text-center">
          <div className="bottom-icon">
            <TakePictureButton />
            {gameState.MeetingId !== null && <ToggleCameraButton />}
          </div>
        </div>
      </div>
    </>
  );
};

export default GameControlPanel;
